import { ChangeDetectionStrategy, Component } from '@angular/core';
import { COPYRIGHT_YEAR } from '../../../app.constants';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterComponent {
  protected readonly copyrightYear = COPYRIGHT_YEAR;
}
